import { UserImageComponent } from '@/global/user-image.component';
import { UsersService } from '@/services/api/users.service';
import { AppAuthService } from '@/services/app/auth.service';
import { CommonModule } from '@angular/common';
import { Component, effect } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Subscription } from 'rxjs';
import { genericProfileImg } from 'src/app/services/data/generic-profile';

@Component({
    selector: 'app-profile-settings',
    imports: [
        CommonModule,
        UserImageComponent,
        ButtonModule
    ],
    template: `
                <div class="flex flex-col gap-7">
                    <div class="text-surface-900 dark:text-surface-0 font-semibold text-base">Profile</div>

                    <div class="flex gap-10 flex-col-reverse md:flex-row">
                        <div class="flex-auto flex flex-col gap-6">
                            <div class="flex flex-col gap-2">
                                <label for="email" class="text-surface-900 dark:text-surface-0">Name</label>
            <input id="email" type="text" *ngIf="profileData" [disabled]="true" pInputText [value]="profileData.displayName || profileData.DisplayName" class="w-full" >
                            </div>

                            <div class="flex flex-col gap-2">
                                <label for="email" class="text-surface-900 dark:text-surface-0">Email</label>
            <input id="email" type="text" *ngIf="profileData" [disabled]="true" pInputText [value]="profileData.userPrincipalName  || profileData.User" class="w-full">
                            </div>
                            <div class="flex flex-col gap-2">
                            <div class="text-800 mb-2" style="line-height: 1.5; font-style: italic;">
                            These settings are linked to you microsoft profile. to change them, update your microsoft profile in Microsoft Delve: </div>
                            </div>
                            <div class="flex flex-col gap-2">
                            <p-button pRipple (click)="launchEdit()" label="Update Profile Settings" class="w-auto"/>
                            </div>
                           
                        </div>

                        <div class="flex flex-col gap-2">
                            <label class="text-surface-900 dark:text-surface-0">Profile Picture</label>
                            
                            <div class="flex flex-col items-center gap-3">
                            <app-user-image [image]="largeImage" [size]="'medium'" [type]="'square'"></app-user-image>
                            </div>
                        </div>
                    </div>

                </div>


<!-- 
    <div class="flex gap-5 flex-column-reverse md:flex-row">
    <div class="flex-auto p-fluid">
        <div class="mb-4">
            <label for="email" class="block font-medium text-900 mb-2">Name</label>
            <input id="email" type="text" *ngIf="profileData" [disabled]="true" pInputText [value]="profileData.displayName || profileData.DisplayName">
        </div>
        <div class="mb-4">
            <label for="email" class="block font-medium text-900 mb-2">Email</label>
            <input id="email" type="text" *ngIf="profileData" [disabled]="true" pInputText [value]="profileData.userPrincipalName  || profileData.User">
        </div>
        <div>
            <div class="text-800 mb-2" style="line-height: 1.5; font-style: italic;">These settings are linked to you microsoft profile. to change them, update your microsoft profile in Microsoft Delve: </div><button pButton pRipple (click)="launchEdit()" label="Update Profile Settings" class="w-auto"></button>
        </div>
    </div>
    <div class="flex flex-column align-items-center flex-or">
        <span class="font-medium text-900 mb-2">Profile Picture</span>
        <app-user-image [image]="largeImage" [size]="'large'"></app-user-image>
        <button pButton type="button" icon="pi pi-cog" class="p-button-rounded -mt-4" (click)="launchEdit()"></button>
    </div>
</div> -->
    `,
    standalone: true,
})
export class ProfileSettingsComponent {
  profileSubscription!: Subscription;
  selectedTab: string = 'profile';
  editLink: string = '';
  largeImage: string = '';
  genericPersonImage: string = genericProfileImg;

  constructor(public profileService: AppAuthService, private usersService: UsersService) {
    effect(() => {
      const profile = this.profileService.userData();
      if(profile) {
        this.editLink = `https://nam.delve.office.com/?u=${profile.AzureID}&v=editprofile`;
        this.profileService.getLargeUserProfileImage().subscribe(
          image => {
            if(image) {
              this.largeImage = image;
            }
            
          },
          error => {
            console.error('Failed to fetch large profile image', error);
          }
        );
      }
    });
  }

  get profileData() {
    return this.profileService.userData();
  }

  launchEdit() {
    window.open(this.editLink, '_blank');
  }

  // ngOnDestroy() {
  //   this.profileSubscription.unsubscribe();
  // }
}